import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ViewIssuesModalPage } from './view-issues-modal.page';

const routes: Routes = [
  {
    path: '',
    component: ViewIssuesModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ViewIssuesModalPage]
})
export class ViewIssuesModalPageModule {}
